<template lang="pug">
  #summary
    v-container(fluid)
      changeDialog(ref="changeModal" v-bind:data="confiramtionData")
      v-expansion-panels.mb-5(flat hover accordion v-if="userPermissions.createTags")
        v-expansion-panel.mr-5
          v-expansion-panel-header
            v-col(xs=12 sm=12)
              v-card(flat)
                p.small.bold.pl-2 Gestionar etiquetas
          v-expansion-panel-content
            v-row
              v-col(xs=12 sm=4)
                v-row.tag-list.mt-4
                  v-col.tag.py-2(xs=12 sm=12 v-if="!allTags.length > 0")
                    p.field-title.small.mb-0.ml-1 Aún no hay etiquetas registradas
                  v-col.tag.py-2(xs=12 sm=12 v-if="allTags.length > 0" v-for="(tag, index) in allTags" :key="index" @click="selectTag(tag)" :class="{ 'toggle-tag': tag.clicked }")
                    p.field-title.small.mb-0.ml-1 {{tag.text}}
                v-row.new-tag.mt-2
                  v-btn.main-background.save.bolder(@click="addTag()") Nueva etiqueta
              v-col.px-5(xs=12 sm=7 v-if="selectedTag")
                label.custom.bold.px-3 {{edit ? 'Editar etiqueta' : 'Nueva etiqueta'}}
                v-text-field.px-3(
                  v-model="selectedTag.text"
                  hide-details
                  class="input-group--focused"
                )
                v-row.justify-end.mt-4
                  v-btn.main-background.save.bolder.smaller.mx-3(@click="updateTag()" v-if="edit") Guardar cambios
                  v-btn.main-background.save.bolder.smaller.mx-3(@click="newTag()" v-else) Guardar etiqueta
                  v-btn.white-btn.save.bolder.smaller(v-if="edit" @click="deleteTag()") Eliminar etiqueta
                  v-btn.white-btn.save.bolder.smaller(v-else @click="cancelNewTag()") Cancelar

      v-row
        v-col(xs=12 sm=12)
          v-card.pt-4(flat)
            label.custom.bold Etiquetas relacionadas con el caso:
            //p {{allTags}}
            //p {{tags}}
            v-card-title.pa-0.searchbar
              //v-text-field.px-3.search(
                v-model="searchWords"
                append-icon="search"
                hide-details
                class="input-group--focused"
                )
              v-select(
                v-model="tags"
                :items="allTags"
                return-object
                chips
                @change="sortTags"
                multiple)
      v-row.mt-5
        v-col.mt-5(xs=11, sm=12)
          v-form.mt-4
            v-row.py-1
              v-textarea(
                v-model="background"
                label="Antecedentes"
                multi-line
              )

            v-row.py-1(align="end" justify="space-between")
              v-textarea(
                v-model="facts"
                label="Hechos"
                multi-line
              )

</template>

<script>
import ChangeDialog from "./ChangeDialog.vue";

export default {
  name: "Summary",
  components: {
    ChangeDialog
  },
  data() {
    return {
      confiramtionData: {},
      searchWords: "",
      selection: [],
      selectedTag: undefined,
      emptyTag: {
        text: ""
      },
      edit: false
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
    allTags: {
    	get() {
    		return this.$store.state.allTags;
    	},
    	set(value) {
    		this.$store.state.allTags = value;
    	}
    },
    background: {
    	get() {
    		return this.$store.state.record.summary.background;
    	},
    	set(value) {
    		this.$store.state.record.summary.background = value;
    	}
    },
    tags: {
    	get() {
    		return this.$store.state.record.tags;
    	},
    	set(value) {
    		this.$store.state.record.tags = value;
    	}
    },
    facts: {
      get() {
    		return this.$store.state.record.summary.facts;
    	},
    	set(value) {
    		this.$store.state.record.summary.facts = value;
    	}
    }
  },
  methods: {
    selectTag(t) {
      this.allTags.forEach(el => el.clicked = false);
      t.clicked = true;
      this.selectedTag = Object.assign({}, t);
      this.edit = true;
    },
    addTag() {
      this.allTags.forEach(el => el.clicked = false);
      this.selectedTag = Object.assign({}, this.emptyTag);
      this.edit = false;
    },
    newTag() {
      this.$store.dispatch("createTags", this.selectedTag)
        .then(result => {this.getTags(); this.cancelNewTag();})
        .catch(err => console.log(err));
    },
    async updateTag() {
      this.confiramtionData = {
        action: 'actualizar',
        entity: 'etiqueta',
        entityGenre: 'f'
      };
      if (await this.$refs.changeModal.pop()) {
        this.$store.dispatch("updateTag", this.selectedTag)
          .then(async (result) => {
            await this.getTags();
            await this.cancelNewTag();
          })
          .catch(err => console.log(err));
      } else {
        this.cancelNewTag();
      }
    },
    cancelNewTag() {
      this.selectedTag = undefined;
      this.allTags.forEach(el => el.clicked = false);
      this.edit = false;
    },
    async deleteTag() {
      this.confiramtionData = {
        action: 'eliminar',
        entity: 'etiqueta',
        entityGenre: 'f'
      };
      if (await this.$refs.changeModal.pop()) {
        this.$store.dispatch("deleteTag", this.selectedTag._id)
          .then(result => {this.getTags(); this.cancelNewTag();})
          .catch(err => console.log(err));
      }
    },
    sortTags() {
      this.tags.sort();
      //console.log(this.tags);
    },
    getTags() {
      this.$store.dispatch("getTags")
        .then(result => {
          this.allTags = result.data.result;
          this.allTags.sort((a,b) => a.text > b.text ? 1 : a.text == b.text ? 0 : -1);
        })
        .catch(err => console.log(err));
    }
  },
  watch: {
    searchWords: async function(val) {
      val = val.toLowerCase();
      return "";
    }
  },
  async mounted() {
    this.getTags();
  }
};
</script>

<style scoped lang="scss">

.col {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.search {
  background-color: $postal-border-color;
  color: $font-color-dark;
  border-radius: 7px;
  font-weight: 700;
  font-size: 19px;
  height: 40px;
  padding-top: 3px;
  .input-group__input {
    input {
      font-size: 19px;
    }
    .input-group__append-icon {
      font-weight: normal !important;
    }
  }
  .input-group__details {
    display: none;
  }
}
.tag-list {
  max-height: 300px;
  overflow-y: scroll;
  //border-right: 1px solid #949494;
  .tag.toggle-tag,
  .tag.toggle-tag:hover {
    background-color:rgba(114, 40, 123, 0.25);
  }
  .tag {
    cursor: pointer;
    //overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px 17px;
    &:hover {
      background-color: $main-color-light;
    }
  }
}
</style>
